import { render, staticRenderFns } from "./SaleProfitList.vue?vue&type=template&id=9ff038c0&scoped=true"
import script from "./SaleProfitList.vue?vue&type=script&lang=js"
export * from "./SaleProfitList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff038c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ff038c0')) {
      api.createRecord('9ff038c0', component.options)
    } else {
      api.reload('9ff038c0', component.options)
    }
    module.hot.accept("./SaleProfitList.vue?vue&type=template&id=9ff038c0&scoped=true", function () {
      api.rerender('9ff038c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/sale-profit/SaleProfitList.vue"
export default component.exports